/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Tc, $, debug) {
	'use strict';

	/**
	 * Richtext
	 *	- Copy class to headlines that contain a spitzmarke, so that the margins can be removed
	 *
	 * Used for Desktop and Mobile
	 *
	 * @author Cesar Keller
	 */
	Tc.Module.RichText = Tc.Module.extend({

		on: function (callback) {
			var $ctx = this.$ctx;

			var $spitzmarke = $ctx.find('.scs-spitzmarke-dachzeile');
			if ($spitzmarke.length) {
				$spitzmarke.closest('h2, h3, h4, h5').addClass('scs-spitzmarke-dachzeile');
				debug.log('Tc.Module.Richtext > found scs-spitzmarke-dachzeile', $spitzmarke.length);
			}
			callback();
		},

		after: function() {
			var hasSensitiveData = this.$ctx.data('has-sensitive-data');

			if (hasSensitiveData) {
				this.hideSensitiveData();
			}
		},

		hideSensitiveData: function() {
			this.$ctx.find('*').addClass('ctHidden');
		}
	});
}(window.Tc, window.Tc.$, window.debug));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.Richtext.js
// module id = 176
// module chunks = 0